import React, { useState, useEffect } from 'react';
import AssessmentWrapper from '../../AssessmentWrapper';
import { Modal } from "antd";
import { addAssessment } from '../../../../services/assessment';
import { useRecoilValue } from 'recoil';
import { assessmentAtom } from "../../../../state/assessment";
import Close from "../../../../resources/imgs/modal/close.svg";
import Progress from "../../progress";
import HelpBtn from "../../../../resources/imgs/assessment/helpBtn.svg";

var initialRes = {
  module: 5,
  moduleKey: "ink_color",
  stroopItems: []
}

// Module 5 content component
function Module5_2Content(props) {
  const { onModuleComplete, moduleType, recordScore, handleModuleComplete, ...otherProps } = props;
  const assessment = useRecoilValue(assessmentAtom);

  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [startTime, setStartTime] = useState(null);
  const [initialData, setInitialData] = useState([
    { question: ["Red", "color-blue"], answer1: ["Blue", "color-blue"], answer2: ["Red", "color-red"], rule: "color", correctAnswer: "Blue" },
    { question: ["Brown", "color-green"], answer1: ["Green", "color-green"], answer2: ["Brown", "color-brown"], rule: "meaning", correctAnswer: "Brown" },
    { question: ["Blue", "color-red"], answer1: ["Red", "color-red"], answer2: ["Blue", "color-blue"], rule: "color", correctAnswer: "Red" },
    { question: ["Green", "color-yellow"], answer1: ["Yellow", "color-yellow"], answer2: ["Green", "color-green"], rule: "color", correctAnswer: "Yellow" },
    { question: ["Yellow", "color-purple"], answer1: ["Yellow", "color-yellow"], answer2: ["Purple", "color-purple"], rule: "color", correctAnswer: "Purple" },
    { question: ["Brown", "color-orange"], answer1: ["Orange", "color-orange"], answer2: ["Brown", "color-brown"], rule: "meaning", correctAnswer: "Brown" },
    { question: ["Purple", "color-blue"], answer1: ["Purple", "color-purple"], answer2: ["Blue", "color-blue"], rule: "color", correctAnswer: "Blue" },
    { question: ["Orange", "color-brown"], answer1: ["Orange", "color-orange"], answer2: ["Brown", "color-brown"], rule: "color", correctAnswer: "Brown" },
    { question: ["Green", "color-purple"], answer1: ["Purple", "color-purple"], answer2: ["Green", "color-green"], rule: "color", correctAnswer: "Purple" },
    { question: ["Brown", "color-red"], answer1: ["Brown", "color-brown"], answer2: ["Red", "color-red"], rule: "meaning", correctAnswer: "Brown" },
    { question: ["White", "color-green"], answer1: ["Green", "color-green"], answer2: ["White", "color-white"], rule: "color", correctAnswer: "Green" },
    { question: ["Yellow", "color-blue"], answer1: ["Yellow", "color-yellow"], answer2: ["Blue", "color-blue"], rule: "color", correctAnswer: "Blue" },
    { question: ["Red", "color-yellow"], answer1: ["Yellow", "color-yellow"], answer2: ["Red", "color-red"], rule: "color", correctAnswer: "Yellow" },
    { question: ["Blue", "color-purple"], answer1: ["Blue", "color-blue"], answer2: ["Purple", "color-purple"], rule: "color", correctAnswer: "Purple" },
    { question: ["Green", "color-brown"], answer1: ["Brown", "color-brown"], answer2: ["Green", "color-green"], rule: "color", correctAnswer: "Brown" },
    { question: ["Brown", "color-black"], answer1: ["Brown", "color-brown"], answer2: ["Black", "color-black"], rule: "meaning", correctAnswer: "Brown" },
    { question: ["Orange", "color-green"], answer1: ["Orange", "color-orange"], answer2: ["Green", "color-green"], rule: "color", correctAnswer: "Green" },
    { question: ["Purple", "color-orange"], answer1: ["Purple", "color-purple"], answer2: ["Orange", "color-orange"], rule: "color", correctAnswer: "Orange" },
    { question: ["Black", "color-blue"], answer1: ["Blue", "color-blue"], answer2: ["Black", "color-black"], rule: "color", correctAnswer: "Blue" },
    { question: ["Brown", "color-yellow"], answer1: ["Brown", "color-brown"], answer2: ["Yellow", "color-yellow"], rule: "meaning", correctAnswer: "Brown" },
  ]);

  // Start timer when component mounts
  useEffect(() => {
    setStartTime(Date.now());
    console.log('🕐 Module 5 timer started');
  }, []);

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const nextStep = async (answer) => {
    const isCorrect = answer === initialData[index].correctAnswer;
    
    // Record score for this instance
    if (recordScore) {
      recordScore(isCorrect, {
        questionId: index + 1,
        userAnswer: answer,
        correctAnswer: initialData[index].correctAnswer,
        questionType: 'stroop-task',
        rule: initialData[index].rule,
        word: initialData[index].question[0]
      });
    }
    
    initialRes.stroopItems.push({
      word: initialData[index].question[0],
      inkColor: initialData[index].question[1],
      rule: initialData[index].rule,
      userAnswer: answer,
      correctAnswer: initialData[index].correctAnswer,
      isCorrect: isCorrect
    })

    if (index === 19) {
      console.log(initialRes);
      // Calculate total score and time
      const correctCount = initialRes.stroopItems.filter(item => item.isCorrect).length;
      const totalTime = startTime ? Date.now() - startTime : 0;
      console.log(`🕐 Module 5 completed with ${correctCount}/20 correct answers in ${totalTime}ms`);
      
      if (handleModuleComplete) {
        // Delay handleModuleComplete to allow score popup to display
        setTimeout(() => {
          handleModuleComplete({
            completedQuestions: 20,
            totalQuestions: 20,
            correctAnswers: correctCount,
            allAnswers: initialRes.stroopItems,
            moduleType: '5',
            totalTime: totalTime
          });
        }, 2500);
      } else if (onModuleComplete) {
        onModuleComplete({
          moduleType,
          score: correctCount,
          totalQuestions: 20,
          responses: initialRes.stroopItems,
          totalTime: totalTime
        });
      } else {
        props.nextPage();
      }
    } else {
      setIndex(index + 1);
    }
  }

  return (
    <div className="module1-main">
      <div className="module1-wrap">
        <Progress number="05." percent={5 / 8} />
        <div className="module1-content-wrap">
          <div className="module1-logo">Module 5</div>
          <div className="module1-body">
            <div className="module1-title">Their eye color</div>

            <div className="module1-content1">
              Focus on the details in this challenge. Can you remember the eye
              color of the guests? Pay close attention and see if you can
              accurately identify the correct eye color from the options
              provided.
            </div>

          </div>
        </div>
      </div>

      <div className="module1-categories"></div>
      <div className={`module1-title text-center ${initialData[index].question[1]}`}>{initialData[index].question[0]}</div>
      <div className="module1-categories"></div>
      <div className='module5-color-group'>
        <div className="module5-color-item" onClick={() => nextStep(initialData[index].answer1[0])}>
          {initialData[index].answer1[0]}
        </div>

        <div className="module5-color-item" onClick={() => nextStep(initialData[index].answer2[0])}>
          {initialData[index].answer2[0]}
        </div>
      </div>

      <div className='next-btn-group'>
        <div className='help-btn-group'>
          <div className='help-btn-effect1'></div>
          <div className='help-btn-effect2'></div>
          <img src={HelpBtn} onClick={() => showModal()} />
          <div className='help-content'>Do you need help?</div>
        </div>
      </div>

      <Modal
        open={open}
        onOk={() => showModal()}
        onCancel={() => hideModal()}
        closeIcon={<img src={Close}></img>}
        footer={null}
      >
        <div className="direction-modal-container">
          <div className='direction-modal-title'>Directions</div>
          <div className="assessment1-content">
            Now that you've served the 6 guests, you notice that your love interest's eye color is brown. In the following test, you have to show you're able to think on your feet about their eye color.You'll get a word representing a color like red, blue, green, brown, and yellow.  But the color of the word won't match the color of the meaning of the word.  For every color but brown, your task is to select the color of the word.  But when the word's meaning is the eye color of your love interest, you must select the meaning of the word instead.
          </div>
          <div className="assessment1-wrap module5-instruction">
            <div className="assessment1-content">
              Example:
            </div>

            <div className="assessment1-content font-600 color-red">
              Red
            </div>

            <div className="assessment1-content">
              <div>The correct answer <span className='color-blue'>is blue</span></div>
              <div>
                Explanation: Since the word doesn't mean "brown", we choose the color of the word meaning of the word.
              </div>
            </div>

            <div className="assessment1-content font-600 color-brown">
              Brown
            </div>

            <div className="assessment1-content">
              <div>The correct answer <span className='color-brown'>is brown</span></div>
              <div>
                Explanation: Since the word doesn't mean "brown", we choose the meaning of the word color of the word
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

// Scored wrapper for Module 5
export const ScoredModule5_2 = (props) => {
  return (
    <AssessmentWrapper 
      moduleType="5" 
      isAdaptive={false}
      onModuleComplete={props.onModuleComplete}
    >
      <Module5_2Content {...props} />
    </AssessmentWrapper>
  );
};

export default Module5_2Content;